import { connectedRouterRedirect } from 'redux-auth-wrapper/history4/redirect';
import locationHelperBuilder from 'redux-auth-wrapper/history4/locationHelper';
import { State } from '@app/store/root-reducer';
import { selectTokenValid } from '@app/common/auth/auth.selectors';

const locationHelper = locationHelperBuilder({});

const basePath = process.env.REACT_APP_BASE_PATH || '';

const userIsAuthenticatedDefaults = {
  authenticatedSelector: (state: State) => {
    // Check if redux-persist rehydration is complete
    const rehydrated = state.common.auth._persist?.rehydrated;
    
    // Only validate token if redux state is rehydrated
    if (!rehydrated) {
      // Return true during rehydration to prevent flashing login screen
      return true;
    }
    
    return selectTokenValid(state);
  },
  wrapperDisplayName: 'UserIsAuthenticated',
};

export const userIsAuthenticatedRedir = connectedRouterRedirect({
  ...userIsAuthenticatedDefaults,
  redirectPath: `${basePath}/auth/login`
});

export const userIsNotAuthenticated = connectedRouterRedirect({
  redirectPath: (_, ownProps) => locationHelper.getRedirectQueryParam(ownProps) || `${basePath}/dashboard`,
  allowRedirectBack: false,
  authenticatedSelector: (state: State) => {
    // Check if redux-persist rehydration is complete
    const rehydrated = state.common.auth._persist?.rehydrated;
    
    // Only validate token if redux state is rehydrated
    if (!rehydrated) {
      // Return false during rehydration
      return false;
    }
    
    return !selectTokenValid(state);
  },
  wrapperDisplayName: 'UserIsNotAuthenticated'
})